import { createContext } from "react";

export const CrawlerContext = createContext(false);
